// extracted by mini-css-extract-plugin
export var dividerLine = "_56-0";
export var errorBackground = "_56-1";